import { PfeBaseCondition } from '../conditions.model';
import { ExpressionCondition } from './../rules-evaluator/index';

export const PFE_EXPRESSION = 'PFE_EXPRESSION';

/**
 * "PFE_EXPRESSION" condition.
 * Will return the result of evaluate the expression
 * @example
 *
 * ```json
 * {
 *   "type": "PFE_EXPRESSION";
 *   "expression": "{$.myFancyExpression}"
 * }
 * ```
 */
export interface PfeExpressionCondition extends PfeBaseCondition, ExpressionCondition {
  type: typeof PFE_EXPRESSION;
}
